import { twMerge } from 'tailwind-merge';

type SpinnerVariant = 'white';
type SpinnerSize = 'sm' | 'md' | 'lg';

interface SpinnerProps {
    variant?: SpinnerVariant;
    size?: SpinnerSize;
    className?: string;
}

const sizeClasses: Record<SpinnerSize, string> = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
};

const variantClasses: Record<SpinnerVariant, string> = {
    white: 'border-transparent border-t-white',
};

export default function Spinner({ variant = 'white', size = 'md', className = '' }: SpinnerProps) {
    return (
        <div className={twMerge('relative', sizeClasses[size], className)}>
            <div
                className={twMerge(
                    'absolute inset-0 animate-spin rounded-full border-4',
                    variantClasses[variant]
                )}
            />
        </div>
    );
}
